export const queryUsersKey = () => ["users"];
export const queryUserKey = (user_id) => ["users", user_id];
export const queryProfessionalsSearchKey = (search) => [
  "professionals",
  search,
];
export const queryAppointmentsKey = (professional_id, currentWeekStart) => [
  "available-slots",
  professional_id,
  currentWeekStart,
];
export const queryAppointmentsUserKey = (user_id) => [
  "appointments",
  "users",
  user_id,
];
export const queryAppointmentsProfessionalKey = (user_id) => [
  "appointments",
  "professionals",
  user_id,
];
export const queryUsersUsernameValidationKey = (param) => [
  "usersUsernameValidation",
  param,
];
export const queryUsersEmailValidationKey = (param) => [
  "usersEmailValidation",
  param,
];
export const queryMedicalHistoryKey = (userId) => ["medicalHistoryKey", userId];
export const queryDoctorSecretariesKey = (doctorId) => [
  "doctorSecretaries",
  doctorId,
];
export const queryPatientHealthHistoryKey = (patientId) => [
  "patientHealthHistory",
  patientId,
];
export const queryDependentsKey = (guardianId) => ["dependents", guardianId];
export const queryInventoryOwnersKey = (userId) => ["inventory", "owners", userId];
export const queryInventorySettingsKey = (ownerId) => ["inventory", "settings", ownerId];
export const queryInventorySuppliesKey = (ownerId, q = "") => [
  "inventory",
  "supplies",
  ownerId,
  q,
];
export const queryInventoryReorderKey = (ownerId) => ["inventory", "reorder", ownerId];
export const queryInventoryExpiringKey = (ownerId, today) => [
  "inventory",
  "expiring",
  ownerId,
  today,
];
export const queryInventorySupplyHistoryKey = (supplyId) => [
  "inventory",
  "supplyHistory",
  supplyId,
];
export const queryInventoryTreatmentsKey = (ownerId) => ["inventory", "treatments", ownerId];
export const queryInventoryTreatmentStatsKey = (treatmentId) => [
  "inventory",
  "treatmentStats",
  treatmentId,
];
export const queryInventoryAnalyticsKey = (ownerId) => ["inventory", "analytics", ownerId];
